import {Component, OnInit, ViewChild} from '@angular/core';

import {AlertService, AuthenticationService, ClientProfileService, ProjectService} from '../../_services/index';

import {ActivatedRoute, Router} from '@angular/router';

import {PoamItem, Project, User} from '../../_models/index';
import {LoginHelper} from '../../helpers';
import {IndexConfigService} from "../../_services/index.config.service";
import {ActionPlan} from "../../_models/actionPlan";
import {FormBuilder, Validators} from "@angular/forms";
import {SelectProjectControlItemComponent} from "../selectProjectControlItem/select-project-control-item.component";
import {
  SelectSingleProjectControlItemComponent
} from "../selectSingleProjectControlItem/select-single-project-control-item.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import { DictionaryService } from "../../_services/dictionary.service";
import { AppTextResourcesService } from '../../_services/app.text.resources.service';
import {AddSignatureComponent} from "../addSignature/addSignature.component";
import {Constants} from "../../helpers/constants";
import {Log} from "oidc-client";

@Component({
    standalone: false,
  selector: "globalTrustReport-component",
  templateUrl: 'globalTrustReport.component.html',
  styleUrls: ['./globalTrustReport.component.scss'],
})

export class GlobalTrustReportComponent implements OnInit {
  settings: any = {};
  tenantName: string;
  api: string;
  window = window;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public alertService: AlertService,
    public clientProfileService: ClientProfileService) {
    this.api = window.location.origin || Constants.DefaultApiHost;
  }

  ngOnInit() {

    const tenantName = this.tenantName = LoginHelper.getTenantName() || LoginHelper.getTenantNameFromUrl();
    this.clientProfileService.getPublicSettings(tenantName).subscribe(s => {
      this.settings = s;
      if (!this.settings.trustReportIsPublished) {
        this.router.navigate(['/login']);
      }
    });
  }
}
